import { css } from "@emotion/css"
import { useEffect, useState } from "react"

import Stack from "@p-ban/common/src/components/layout/Stack"

import type { ManufactureResult, MountResult, ResultsPerCourse } from "../../../types/parsedResult"
import COLOR_CODE from "../../constant/color"
import DebugMode from "../../service/DebugMode"

type Props = {
  design: boolean
  manufacture?: ResultsPerCourse<ManufactureResult>
  mount?: MountResult
}

/**
 * 工場リスト表示コンポーネント
 * - 製造、実装の各工程の、コースごとの工場を表示する。
 * - デバッグモード時のみ表示する。
 * @param design
 * @param manufacture
 * @param mount
 */
const FactoryList = ({ design, manufacture, mount }: Props) => {
  const [debugModeEnabled, setDebugModeEnabled] = useState(DebugMode.isEnabled)

  useEffect(() => DebugMode.addListener(setDebugModeEnabled), [])

  if (!debugModeEnabled) return null

  const manufactureTop = 54 + (design ? 82 : 0)
  const mountTop = manufactureTop + (manufacture ? 206 : 0)

  return (
    <div className={styles.wrapper}>
      {manufacture && (
        <div className={styles.list} style={{ top: manufactureTop }}>
          <Stack direction="column" spacing={5}>
            <div className={mount ? styles.course : styles.deliveryZeroCourse}>
              工場：{manufacture.ultraQuick.factory ?? "-"}
            </div>
            <div className={styles.course}>工場：{manufacture.superQuick.factory ?? "-"}</div>
            <div className={styles.course}>工場：{manufacture.quick.factory ?? "-"}</div>
            <div className={styles.course}>工場：{manufacture.normal.factory ?? "-"}</div>
            <div className={styles.course}>工場：{manufacture.massProduction.factory ?? "-"}</div>
          </Stack>
        </div>
      )}
      {mount && (
        <div className={styles.list} style={{ top: mountTop }}>
          工場：{getMountFactory(mount.factoryId)}({getMountWay(mount.mountWay)})
        </div>
      )}
    </div>
  )
}

export default FactoryList

const getMountFactory = (id: string | null) => {
  switch (id) {
    case "140":
      return "A"
    case "154":
      return "M"
    default:
      return "-"
  }
}

const getMountWay = (id: string | null) => {
  switch (id) {
    case "1":
      return "手付け"
    case "2":
      return "手載せ"
    case "3":
      return "マウンター"
    default:
      return "-"
  }
}

const styles = {
  wrapper: css`
    position: relative;
    > div {
      position: absolute;
      left: -100px;
    }
  `,
  list: css`
    width: 100px;
    background-color: ${COLOR_CODE.WHITE};
    border: 3px solid ${COLOR_CODE.GREEN};
  `,
  course: css`
    height: 26px;
  `,
  deliveryZeroCourse: css`
    height: 52px;
  `,
}
